import { render, staticRenderFns } from "./PortalItemList.vue?vue&type=template&id=e62772e0"
import script from "./PortalItemList.ts?vue&type=script&lang=ts"
export * from "./PortalItemList.ts?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.0.10@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports